module.exports = __webpack_public_path__ + "img/orange_018.0abf0986.png";